/**
 * First-use labels: the screens carry the names Carolina knows from her Excel workbook (PRO-7).
 * Route paths stay `/pm` and `/pm/timeline`; only the visible labels follow the sheets.
 */
export const PM_SCREENS = {
  /** v1.3: a person's open tasks and gate deadlines (no Excel sheet). */
  myWork: { title: 'My work', subtitle: 'Your tasks and gate deadlines' },
  /** The "Master List" sheet. */
  projects: { title: 'Projects', subtitle: 'Master list' },
  /** The "Follow-up" sheet (weeks 1–52/53). */
  followUp: { title: 'Follow-up', subtitle: 'Yearly timeline' },
} as const;
